
<div class="page-header">
  <div>
    <h1>Parceiros</h1>
    <p>Gerencie parceiros, dados cadastrais e limites de usuários.</p>
  </div>

  <button
    type="button"
    class="btn btn-primary"
    (click)="novo()"
    [disabled]="salvando"
  >
    + Novo parceiro
  </button>
</div>

<!-- MENSAGENS -->
<p *ngIf="erro" class="error-message">
  {{ erro }}
</p>

<p *ngIf="sucesso" class="success-message">
  {{ sucesso }}
</p>

<!-- FORMULÁRIO -->
<div class="card" *ngIf="mostrar">

  <h3>
    {{ editando ? 'Editar parceiro' : 'Cadastrar parceiro' }}
  </h3>

  <p class="form-description">
    Preencha os dados do parceiro. Os campos marcados com * são obrigatórios.
  </p>

  <form class="form-grid" (ngSubmit)="salvar()" #parceiroForm="ngForm">

    <!-- DADOS DO PARCEIRO -->
    <div class="form-group">
      <label for="nome">Nome do parceiro *</label>
      <input
        id="nome"
        class="form-control"
        type="text"
        name="nome"
        [(ngModel)]="form.nome"
        required
        maxlength="200"
        placeholder="Nome da empresa ou instituição"
      />
    </div>

    <div class="form-group">
      <label for="cpfCnpj">CPF / CNPJ *</label>

      <input
        id="cpfCnpj"
        class="form-control"
        type="text"
        name="cpfCnpj"
        [(ngModel)]="form.cpfCnpj"
        (input)="mascararCpfCnpj()"
        #documentoCtrl="ngModel"
        required
        maxlength="18"
        inputmode="numeric"
        autocomplete="off"
        [pattern]="padraoCpfCnpj"
        placeholder="000.000.000-00 ou 00.000.000/0000-00"
      />

      <small
        class="field-error"
        *ngIf="documentoCtrl.invalid && documentoCtrl.touched"
      >
        Informe um CPF com 11 dígitos ou CNPJ com 14 dígitos.
      </small>

      <small class="field-hint">
        O documento deve pertencer ao parceiro cadastrado.
      </small>
    </div>

    <div class="form-group">
      <label for="emailAcesso">E-mail de acesso *</label>

      <input
        id="emailAcesso"
        class="form-control"
        type="email"
        name="emailAcesso"
        [(ngModel)]="form.emailAcesso"
        #emailCtrl="ngModel"
        required
        email
        maxlength="254"
        placeholder="contato@empresa.com.br"
      />

      <small
        class="field-error"
        *ngIf="emailCtrl.invalid && emailCtrl.touched"
      >
        Informe um e-mail válido.
      </small>
    </div>

    <div class="form-group">
      <label for="telefone">Telefone</label>

      <input
        id="telefone"
        name="telefone"
        type="tel"
        class="form-control"
        inputmode="tel"
        autocomplete="tel"
        [(ngModel)]="form.telefone"
        (ngModelChange)="mascararTelefone()"
        placeholder="+55 (62) 99369-4073"
        maxlength="19"
        required
      />
    </div>

    <div class="form-group">
      <label for="limiteUsuarios">Limite de usuários *</label>
      <input
        id="limiteUsuarios"
        class="form-control"
        type="number"
        name="limiteUsuarios"
        [(ngModel)]="form.limiteUsuarios"
        required
        min="1"
        step="1"
      />
    </div>

    <div class="form-group">
      <label for="cep">CEP *</label>

      <input
        id="cep"
        class="form-control"
        type="text"
        name="cep"
        [(ngModel)]="form.cep"
        (input)="mascararCep(); buscarCep()"
        maxlength="9"
        inputmode="numeric"
        required
        placeholder="00000-000"
      />

      <small *ngIf="buscandoCep" class="field-hint">
        Buscando endereço...
      </small>
    </div>

    <!-- ENDEREÇO -->
    <div class="form-group">
      <label for="rua">Rua / Logradouro *</label>
      <input
        id="rua"
        class="form-control"
        type="text"
        name="rua"
        [(ngModel)]="form.rua"
        required
        placeholder="Rua, avenida ou logradouro"
      />
    </div>

    <div class="form-group">
      <label for="cidade">Cidade *</label>

      <select
        id="cidade"
        class="form-control"
        name="cidade"
        [(ngModel)]="form.cidade"
        [disabled]="!form.estado || carregandoCidades || buscandoCep"
        required
      >
        <option value="">
          {{ carregandoCidades ? 'Carregando cidades...' : 'Selecione a cidade' }}
        </option>

        <option *ngFor="let cidade of cidades" [value]="cidade.nome">
          {{ cidade.nome }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="estado">Estado *</label>

      <select
        id="estado"
        class="form-control"
        name="estado"
        [(ngModel)]="form.estado"
        (ngModelChange)="aoAlterarEstado()"
        [disabled]="carregandoEstados || buscandoCep"
        required
      >
        <option value="">
          {{ carregandoEstados ? 'Carregando estados...' : 'Selecione o estado' }}
        </option>

        <option *ngFor="let estado of estados" [value]="estado.sigla">
          {{ estado.nome }} ({{ estado.sigla }})
        </option>
      </select>
    </div>



    <div class="form-group">
      <label for="pais">País *</label>

      <select
        id="pais"
        class="form-control"
        name="pais"
        [(ngModel)]="form.pais"
        required
      >
        <option *ngFor="let pais of paises" [value]="pais.nome">
          {{ pais.nome }}
        </option>
      </select>
    </div>

    <!-- BOTÕES -->
    <div class="actions">
      <button
        type="button"
        class="btn btn-outline"
        (click)="cancelar()"
        [disabled]="salvando"
      >
        Voltar
      </button>

      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="salvando"
      >
        {{ salvando ? 'Salvando...' : (editando ? 'Atualizar parceiro' : 'Cadastrar parceiro') }}
      </button>
    </div>

  </form>
</div>

<!-- LISTAGEM -->
<div class="card">

  <div class="table-container">
    <table>
      <thead>
      <tr>
        <th>Nome</th>
        <th>CPF / CNPJ</th>
        <th>Telefone</th>
        <th>Limite</th>
        <th>E-mail de acesso</th>
        <th>Situação</th>
        <th>Cadastrado em</th>
        <th>Ações</th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let p of items">

        <td>
          <strong>{{ p.nome }}</strong>
        </td>

        <td>
          {{ p.cpfCnpj ? formatarCpfCnpj(p.cpfCnpj) : '—' }}
        </td>

        <td>
          {{ p.telefone ? formatarTelefone(p.telefone) : '—' }}
        </td>

        <td>
          {{ p.limiteUsuarios }}
        </td>

        <td>
          {{ p.emailAcesso || '—' }}
        </td>

        <td>
            <span
              class="status-badge"
              [class.status-active]="p.ativo"
              [class.status-inactive]="!p.ativo"
            >
              {{ p.ativo ? 'Ativo' : 'Inativo' }}
            </span>
        </td>

        <td>
          {{ p.criadoEm | date:'dd/MM/yyyy HH:mm' }}
        </td>

        <td>
          <div class="actions">
            <button
              type="button"
              class="btn btn-outline"
              (click)="editar(p)"
              [disabled]="salvando || excluindo"
            >
              Editar
            </button>

            <button
              type="button"
              class="btn"
              [class.btn-danger]="p.ativo"
              [class.btn-primary]="!p.ativo"
              (click)="excluir(p)"
              [disabled]="salvando || excluindo"
            >
              {{ excluindo ? 'Aguarde...' : (p.ativo ? 'Inativar' : 'Reativar') }}
            </button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="carregando" class="empty-state">
    Carregando parceiros...
  </p>

  <p
    *ngIf="!carregando && !items.length"
    class="empty-state"
  >
    Nenhum parceiro encontrado.
  </p>

</div>
